import { http } from '../utils/http'

const searchAction = (params,page,size,permissionType) => {
  const url = `/api/v1/permission/resources/type/${permissionType}/page?pageNo=${page-1}&pageSize=${size}`
  return http.post(url, params)
};
const addAction = (params,permissionType) => {
  const url = `/api/v1/permission/resources/type/${permissionType}/add`
  return http.post(url, params)
};
const getAction = (id,permissionType) => {
  const url = `/api/v1/permission/resources/${id}/type/${permissionType}/get`
  return http.post(url)
};
const editAction = (params,id,permissionType) => {
  const url = `/api/v1/permission/resources/${id}/type/${permissionType}/update`
  return http.post(url, params)
};
const deleteAction = (id,permissionType) => {
  const url = `/api/v1/permission/resources/${id}/type/${permissionType}/delete`
  return http.post(url)
};
export default {
  searchAction,
  addAction,
  getAction,
  editAction,
  deleteAction,
}
